<template>
  <div>
    <div class="row pt-3">
      <div class="col-3">
        <div class="select-wrap">
          <label>Carrier name</label>
          <input v-model="carrier.name"
                 type="text"
                 class="form-control"
          />
        </div>
        <error-field :errors="errors" field="name" />
      </div>
    </div>
    <div class="row mb-3 mt-3" v-if="$_can('carriers.percentages.show')">
      <div class="col-2 pr-1">
        <div class="select-wrap amount-wrap">
          <label>Fee</label>
          <span class="dollar">$</span>
          <input class="form-control"
                 type="text"
                 v-model="percentages.fee"
                 placeholder="Fee"
                 :disabled="!$_can('carriers.percentages.store')"
          />
        </div>
      </div>
      <div class="col-2 pr-1">
        <div class="select-wrap amount-wrap">
          <label>Percent</label>
          <span class="percent">%</span>
          <input class="form-control"
                 type="text"
                 v-model="percentages.percent"
                 placeholder="Percent"
                 :disabled="!$_can('carriers.percentages.store')"
          />
        </div>
      </div>
    </div>

    <div class="row mx-0">
      <div class="col py-3 pl-0 text-left">
        <button type="button"
                @click="deleteCarrier(carrier.id)"
                class="btn btn-delete"
                v-if="$_can('carriers.destroy')"
        >
          Delete
        </button>
      </div>
      <div class="col py-3 pr-0 text-right">
        <button class="btn btn-primary ld-ext-right"
                v-if="$_can('carriers.update')"
                :disabled="loadingButton"
                :class="loadingButton ? 'running' : ''"
                @click.prevent="submit"
        >
          Save
          <div class="ld ld-ball ld-flip" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import axios from 'axios';
import toastr from 'toastr';
import ErrorField from '../ErrorField';
import Errors from '../../classes/Errors';

export default {
  components: {
    ErrorField,
  },
  props: {
    carrier: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    assignmentTypes: [],
    loadingButton: false,
    percentage: {
      fee: 0,
      percent: 0,
    },
    errors: new Errors(),
  }),
  computed: {
    percentages() {
      return this.carrier.percentage ? this.carrier.percentage : this.percentage;
    },
  },
  methods: {
    ...mapActions(['getPaginatedCarriers', 'getCarriers']),
    submit() {
      this.loadingButton = true;
      axios
        .put(`carriers/${this.$route.params.id}`, { ...this.carrier })
        .then(() => {
          if (this.$_can('carriers.percentages.store') && this.percentages) {
            axios
              .post(`carriers/${this.$route.params.id}/percentages`, this.percentages)
              .then(() => {
                toastr.success('Successfully updated carrier');
                this.getCarriers();
                this.$emit('updated');
              })
              .catch(err => {
                this.errors.record(err.response.data.error);
              });
          } else {
            toastr.success('Successfully updated carrier');
            this.getCarriers();
            this.$emit('updated');
          }
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        })
        .finally(() => {
          this.loadingButton = false;
        });
    },
    deleteCarrier(id) {
      axios
        .delete(`carriers/${id}`)
        .then(() => {
          toastr.success('Successfully deleted carrier');
          this.$router.push('/carriers');
        })
        .catch(() => {
          toastr.error('You cannot delete carrier since it is used by companies', '', {
            timeOut: 0,
          });
        })
        .finally(() => {
          this.loadingButton = false;
        });
    },
    clearError(event) {
      this.errors.clear(event.target.name);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/carriers/CarriersInfo.vue